import React, { lazy, Suspense } from 'react';
import { MailSearchHeaderProps } from './schema/MailSearchHeaderProps';

const LazyMailSearchHeader = lazy(
    () => import(/* webpackChunkName: "SearchViews" */ './components/MailSearchHeader')
);

/**
 * Export all the lazy wrappers here
 */
export const MailSearchHeader = (props: MailSearchHeaderProps) => (
    <Suspense fallback={null}>
        <LazyMailSearchHeader {...props} />
    </Suspense>
);
